import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";

export interface StatusTabDef {
  value: string;
  label: string;
  /** Omit or pass null to render no badge at all (distinct from a genuine 0). */
  count?: number | null;
}

interface StatusTabsProps {
  tabs: StatusTabDef[];
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
}

/**
 * Presentational tab-list + badge bar shared across src/ pages that show a set of
 * status-scoped tabs (Review, Upload, Transactions, ...). Owns only rendering — data
 * fetching/filtering stays with the caller.
 */
const StatusTabs: React.FC<StatusTabsProps> = ({ tabs, value, onValueChange, children }) => (
  <Tabs value={value} onValueChange={onValueChange}>
    <TabsList>
      {tabs.map((tab) => (
        <TabsTrigger key={tab.value} value={tab.value}>
          {tab.label}
          {tab.count != null && (
            <Badge variant="secondary" className="ml-2">
              {tab.count}
            </Badge>
          )}
        </TabsTrigger>
      ))}
    </TabsList>
    {children}
  </Tabs>
);

export default StatusTabs;
